import {Routes} from "@angular/router";
import {authGuard} from "./app/core/guards/auth.guard";

export const tcRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./app/app.component').then(m => m.AppComponent),
    loadChildren: () => import('./app/tc.application.routes').then(m => m.default),
    canActivate: [authGuard]
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/registration.component').then(m => m.RegistrationComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/password-reset.component').then(m => m.PasswordResetComponent)
  },
  {
    path: 'access-denied',
    loadComponent: () => import('./pages/access-denied.component').then(m => m.AccessDeniedComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./pages/notfound.component').then(m => m.NotfoundComponent)
  }
]
